'use client';

import { useEffect, useRef } from 'react';
import { usePathname } from 'next/navigation';

const TS_PIXEL_BASE = '//tsyndicate.com/api/v1/retargeting/set/5ec0b0cc-cc58-4ba9-9a37-1b23f112a7b3';

function firePixel(action: string, campaign: string) {
  const url = `${TS_PIXEL_BASE}?action=${encodeURIComponent(action)}&campaign=${encodeURIComponent(campaign)}`;
  const img = new Image(1, 1);
  img.src = url;
}

function getCampaign(): string {
  if (typeof window === 'undefined') return 'direct';
  const params = new URLSearchParams(window.location.search);
  return params.get('utm_campaign') || sessionStorage.getItem('ts_campaign') || 'direct';
}

export default function TrafficStarsPixel() {
  const pathname = usePathname();
  const engageFired = useRef(false);

  // Fire visit pixel on every page load
  useEffect(() => {
    const campaign = getCampaign();
    // Store campaign in session so it persists across navigations
    if (campaign !== 'direct') {
      sessionStorage.setItem('ts_campaign', campaign);
    }
    firePixel('visit', campaign);
  }, [pathname]);

  // Fire engage pixel after 10 seconds on site (once per session)
  useEffect(() => {
    if (engageFired.current) return;
    if (sessionStorage.getItem('ts_engaged')) {
      engageFired.current = true;
      return;
    }

    const timer = setTimeout(() => {
      if (!engageFired.current) {
        engageFired.current = true;
        sessionStorage.setItem('ts_engaged', '1');
        firePixel('engage', getCampaign());
      }
    }, 10000);

    return () => clearTimeout(timer);
  }, []);

  return null;
}

/** Call this from the registration success handler */
export function fireSignupPixel() {
  const campaign = getCampaign();
  firePixel('signup', campaign);
}
